export default {
  title: 'Wolt Drive onboarding',
  subtitle: 'Kun synlig for onboarding-ansvarlige.',
  steps: {
    request: {
      title: '1. Anmod om venue hos Wolt',
      description:
        'Kopierer denne restaurants række til det delte Wolt-ark. Indsæt den i kolonne A i næste tomme række, og informer Wolt i den fælles Slack-kanal.',
    },
    activate: {
      title: '2. Bekræft og aktivér',
      description:
        'Indtast det venue-ID, Wolt har tilføjet i arket. Det tjekkes med et testtilbud fra Wolt, før noget gemmes.',
    },
  },
  fields: {
    venue_id: {
      label: 'Wolt venue-ID',
      placeholder: 'f.eks. 6736f9f5f9e2ab82f9150420',
      invalid: 'Et Wolt venue-ID er 24 tegn langt og bruger kun 0–9 og a–f.',
    },
    priority: {
      label: 'Udbyderprioritet',
      options: {
        wolt_primary: 'Wolt primær, behold nuværende udbydere som reserve',
        wolt_only: 'Kun Wolt',
      },
    },
  },
  verification: {
    verified: 'Wolt bekræftede denne venue.',
    failed: 'Wolt kunne ikke bekræfte denne venue.',
    wolt_reason: 'Wolt svarede: {{reason}}',
    unavailable_now: 'Wolt kan ikke levere fra dette sted lige nu ({{reason}}). Du kan stadig gemme det.',
  },
  preview: {
    label: 'Udbyderrækkefølge',
    none: 'ingen',
  },
  hints: {
    internal_delivery:
      'Denne restaurant leverer med egne chauffører. Wolt bruges, når Leveringstilstand nedenfor er sat til eksterne chauffører.',
    invalid_stored_id:
      'Det gemte venue-id {{venueId}} er ikke et gyldigt Wolt venue-id, så Wolt bruges ikke til denne restaurant. Kontrollér og gem det korrekte.',
  },
  buttons: {
    copy_details: 'Kopiér detaljer',
    verify: 'Bekræft',
    save: 'Gem',
  },
  confirm: {
    title: 'Aktivér Wolt Drive?',
    description: 'Gemmer venue-ID {{venueId}} og ændrer udbyderrækkefølgen til: {{providers}}.',
    unsaved_providers: 'Ugemte ændringer til udbyderlisten nedenfor vil blive erstattet.',
    ok: 'Gem',
    cancel: 'Annullér',
  },
  toasts: {
    copied: 'Kopieret',
    copy_failed: 'Kunne ikke kopiere detaljerne. Prøv igen.',
    saved: 'Wolt Drive er sat op for denne restaurant.',
    save_failed: 'Kunne ikke gemme. Prøv igen.',
  },
};
